import { PageShell } from '@/components/layout/PageShell';
import { LinkButton } from '@/components/ui/Button';
import { useI18n } from '@/lib/i18n';
import { usePageTitle } from '@/lib/usePageTitle';

export default function NotFoundPage(): React.JSX.Element {
  const { t } = useI18n();
  usePageTitle(t('common.notFound'));

  return (
    <PageShell>
      <div className="mv-container flex min-h-[60vh] flex-col items-center justify-center gap-6 py-24 text-center">
        <p className="font-display text-display font-light text-border-strong">404</p>
        <h1 className="font-display text-h1 font-normal text-primary">{t('common.notFound')}</h1>
        <p className="max-w-md text-body-lg text-secondary">{t('common.notFoundHint')}</p>
        <div className="flex flex-wrap justify-center gap-3 pt-2">
          <LinkButton to="/" size="lg">
            {t('common.goHome')}
          </LinkButton>
          <LinkButton to="/teachers" size="lg" variant="secondary">
            {t('teachers.viewAll')}
          </LinkButton>
        </div>
      </div>
    </PageShell>
  );
}
